import React, { useState, useEffect } from "react";
import { useAuth } from '../../context/AuthContext';
import './rating.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ChangePassword from "./UI/ChangePassword";
import StudentTicket from "./UI/StudentTicket";
import ManagerTicket from "./UI/ManagerTicket";
import PaymentMethodList from "./UI/PaymentMethodList";
import PaymentRequest from "./UI/PaymentRequest";
import PackagePrice from "./UI/PackagePrice";
import GeneralProfile from "./UI/GeneralProfile";
import { BrowserView, MobileView } from 'react-device-detect';

function Profile() {
    const { user } = useAuth();
    const { setUser } = useAuth();
    const { t } = useTranslation();
    const [selectpackagemessage, setselectpackagemessage] = useState(true);
    const navigate = useNavigate();
    const [bankVis, setBankVis] = useState([]);
    const [packageVis, setPackageVis] = useState([]);
    const [ticketVis, setTicketVis] = useState([]);


    function handleLogout() {
        setUser(false);
        navigate("/auth/login");



    }

    function handleBack() {
        navigate("/");
    }
    function updatesection(event) {
        navigate("/profile/updatesection");
    }
    function onClick(event) {

        let account = document.getElementById("account");
        let bank = document.getElementById("bank");
        if (event.currentTarget.id === "profile") {
            document.getElementById("profile").classList.add("active");
            document.getElementById("editprofile").classList.remove("active");
            document.getElementById("editprofilee").style.display = "none";
            document.getElementById("profiledetail").style.display = "inline";

            if (ticketVis) {
                document.getElementById("ticket").classList.remove("active");
                document.getElementById("ticketdetail").style.display = "none";
            }
            if (packageVis) {
                document.getElementById("account").classList.remove("active");
                document.getElementById("accountdetail").style.display = "none";
            }
            if (bankVis) {
                document.getElementById("bank").classList.remove("active");
                document.getElementById("bankdetail").style.display = "none";
            }
        }
        else if (event.currentTarget.id === "editprofile") {
            document.getElementById("profile").classList.remove("active");
            document.getElementById("editprofile").classList.add("active");
            document.getElementById("editprofilee").style.display = "inline";
            document.getElementById("profiledetail").style.display = "none";

            if (ticketVis) {
                document.getElementById("ticket").classList.remove("active");
                document.getElementById("ticketdetail").style.display = "none";
            }
            if (packageVis) {
                document.getElementById("account").classList.remove("active");
                document.getElementById("accountdetail").style.display = "none";
            }
            if (bankVis) {
                document.getElementById("bank").classList.remove("active");
                document.getElementById("bankdetail").style.display = "none";
            }
        }
        else if (event.currentTarget.id === "account") {
            document.getElementById("editprofile").classList.remove("active");
            document.getElementById("profile").classList.remove("active");
            document.getElementById("editprofilee").style.display = "none";
            document.getElementById("profiledetail").style.display = "none";



            document.getElementById("account").classList.add("active");
            document.getElementById("bank").classList.remove("active");
            document.getElementById("ticket").classList.remove("active");


            document.getElementById("accountdetail").style.display = "inline";
            document.getElementById("bankdetail").style.display = "none";
            document.getElementById("ticketdetail").style.display = "none";
        }
        else if (event.currentTarget.id === "bank") {
            document.getElementById("profile").classList.remove("active");
            document.getElementById("editprofile").classList.remove("active");
            document.getElementById("account").classList.remove("active");
            document.getElementById("bank").classList.add("active");

            document.getElementById("editprofilee").style.display = "none";
            document.getElementById("profiledetail").style.display = "none";
            document.getElementById("accountdetail").style.display = "none";
            document.getElementById("bankdetail").style.display = "inline";
            document.getElementById("ticket").classList.remove("active");
            document.getElementById("ticketdetail").style.display = "none";
        }
        else if (event.currentTarget.id === "ticket") {
            document.getElementById("profile").classList.remove("active");
            document.getElementById("editprofile").classList.remove("active");

            document.getElementById("editprofilee").style.display = "none";
            document.getElementById("profiledetail").style.display = "none";
            document.getElementById("ticket").classList.add("active");
            document.getElementById("ticketdetail").style.display = "inline";
            if (account) {
                account.classList.remove("active");
                document.getElementById("accountdetail").style.display = "none";
            }
            if (bank) {
                bank.classList.remove("active");
                document.getElementById("bankdetail").style.display = "none";
            }
        }

    }

    useEffect(() => {
        setBankVis(true);
        setPackageVis(true);
        setTicketVis(true);
        // üye istrial true ise
        if (user.user.isTrial) {
            if (user.userDetail.sectionId === 1) {
                setselectpackagemessage("Lütfen bölümünüzü seçiniz.");
            }
        }
        // üye istrial true ise
        document.getElementById("profile").classList.add("active");
        document.getElementById("profiledetail").style.display = "inline";
        console.log(user.userDetail)
        if (user.role == "Öğrenci") {
            if (user.userDetail.classId != null) {
                setBankVis(false)
                setPackageVis(false)
                setTicketVis(false)
            }
        }
        if (user.role == "Öğretmen") {
            setBankVis(false)
            setPackageVis(false)
            setTicketVis(false)
        }
    }, []);


    return (
        <div>
            <BrowserView>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3" style={{ marginTop: "3%" }}>
                            <div class="list-group list-group-flush" >
                                <button style={{ marginBottom: "5%" }} className="btn btn-info" onClick={handleBack}>Panele Dön</button>
                                <a class="list-group-item list-group-item-action" id="profile" onClick={onClick} >{t("profile")}</a>
                                <a class="list-group-item list-group-item-action" id="editprofile" onClick={onClick} >{t("editProfile")}</a>
                                {ticketVis && <a class="list-group-item list-group-item-action" id="ticket" onClick={onClick}>{t("ticketssettings")}</a>}
                                {packageVis && <a class="list-group-item list-group-item-action" id="account" onClick={onClick}>{t("packages&prices")}</a>}
                                {bankVis && <a class="list-group-item list-group-item-action" id="bank" onClick={onClick}>{t("financialoperations")}</a>}

                                <button style={{ marginTop: "5%", marginBottom: "3%" }} className="btn btn-secondary" onClick={handleLogout}> {t("singout")}</button>

                            </div>
                        </div>

                        <div className="col-sm-9" style={{ backgroundColor: "white", marginTop: "3%" }}>
                            <br />
                            <h4> {selectpackagemessage} </h4>
                            {selectpackagemessage === "Lütfen bölümünüzü seçiniz." ? <div><br /><button className="btn btn-info" variant="warning" onClick={updatesection}>Sınıf ve bölümünüzü seçiniz.</button><br /><b>Lütfen Finansal işlemler kısmından paket satın alınız.</b></div> : null}
                            <br />
                            <div id="profiledetail" style={{ display: "none" }}>
                                <GeneralProfile />
                            </div>
                            {
                                <div id="editprofilee" style={{ display: "none" }}>
                                    <ChangePassword />
                                </div>
                            }

                            <div id="accountdetail" style={{ display: "none" }}>
                                <PackagePrice />
                            </div>


                            <div id="bankdetail" style={{ display: "none" }}>
                                <PaymentMethodList />
                                <PaymentRequest />
                            </div>

                            <div id="ticketdetail" style={{ display: "none" }}>
                                <div style={{ textAlign: "center" }}>
                                    <h3>{t("ticketssettings")}</h3>
                                </div>
                                {
                                    (() => {
                                        if (user.user.roleName === "Manager") {
                                            return (
                                                <ManagerTicket />
                                            );
                                        }
                                        else if (user.user.roleName === "Student") {
                                            return (
                                                <StudentTicket />
                                            );

                                        }
                                    })()
                                }

                                <br />
                            </div>



                        </div>
                    </div>
                </div >
            </BrowserView>
            <MobileView>
                <div>
                    <div style={{ marginTop: "3%" }}>
                        <div class="list-group list-group-flush" >
                            <button style={{ marginBottom: "5%" }} className="btn btn-info" onClick={handleBack}>Panele Dön</button>
                            <a class="list-group-item list-group-item-action" id="profile" onClick={onClick} >{t("profile")}</a>
                            <a class="list-group-item list-group-item-action" id="editprofile" onClick={onClick} >{t("editProfile")}</a>
                            {ticketVis && <a class="list-group-item list-group-item-action" id="ticket" onClick={onClick}>{t("ticketssettings")}</a>}
                            {packageVis && <a class="list-group-item list-group-item-action" id="account" onClick={onClick}>{t("packages&prices")}   </a>}
                            {bankVis && <a class="list-group-item list-group-item-action" id="bank" onClick={onClick}>{t("financialoperations")}</a>}
                            <button style={{ marginTop: "5%", marginBottom: "3%" }} className="btn btn-secondary" onClick={handleLogout}> {t("singout")}</button>

                        </div>
                    </div>

                    <div style={{ backgroundColor: "white", marginTop: "3%" }}>
                        <br />
                        <h4> {selectpackagemessage} </h4>
                        <br />
                        {/* <div id="profiledetail" style={{ display: "none" }}>
                        <GeneralProfile />
                    </div> */}
                        <div id="profiledetail" style={{ display: "none" }}>
                            <GeneralProfile />
                        </div>
                        {
                            <div id="editprofilee" style={{ display: "none" }}>
                                <ChangePassword />
                            </div>
                        }

                        <div id="accountdetail" style={{ display: "none" }}>
                            <PackagePrice />
                        </div>


                        <div id="bankdetail" style={{ display: "none" }}>
                            <PaymentMethodList />
                            <PaymentRequest />
                        </div>

                        <div id="ticketdetail" style={{ display: "none" }}>
                            <div style={{ textAlign: "center" }}>
                                <h3>{t("ticketssettings")}</h3>
                            </div>
                            {
                                (() => {
                                    if (user.user.roleName === "Manager") {
                                        return (
                                            <ManagerTicket />
                                        );
                                    }
                                    else if (user.user.roleName === "Student") {
                                        return (
                                            <StudentTicket />
                                        );

                                    }
                                })()
                            }

                            <br />
                        </div>



                    </div>
                </div>
            </MobileView >
        </div >
    )

}
export default Profile;
